import { $_app_server } from '@/_helpers'

export const judgeService = {
  getJudge,
  list,
  judge,
  updateJudge,
  deleteJudge,
  getSign,
  getCaseTypes,
  
  getSpecializationTypes,
  updateSpecialization,
  deleteSpecialization,

  getHolidayType,
  getHolidayList,
  addHoliday,
  deleteHoliday,
  addJudge
}

function addJudge (judge) {
  return $_app_server.post('judge/add', judge).then(response => response.data)
}

function getJudge () {
  return $_app_server.get('authjudge').then(response => response.data)
}
function list () {
  return $_app_server.get('judges').then(response => response.data)
}
function judge (id) {
  return $_app_server.get("judges/" + id).then(response => response.data)
}
function updateJudge (judge) {
  return $_app_server.put('judges/update', judge).then(response => response.data)
}
function deleteJudge(id) {
  return $_app_server.delete("judges/" + id + "/del")
}
function getSign (judge) {
  return $_app_server.post('judge/image/sign', judge).then(response => response.data)
}

function getCaseTypes () {
  return $_app_server.get("casetypes").then(response => response.data)
}



function getSpecializationTypes () {
  return $_app_server.get('specialisationtypes').then(response => response.data)
}
function updateSpecialization (specialisation) {
  return $_app_server.put('/specialisation/update', specialisation).then(response => response.data)
}
function deleteSpecialization(id) {
  return $_app_server.delete("specialisation/" + id + "/del")
}



function getHolidayType () {
  return $_app_server.get('holidaytypes').then(response => response.data)
}
function getHolidayList (id) {
  return $_app_server.get('judges/' + id + '/holiday').then(response => response.data)
}
function addHoliday (obj) {
  return $_app_server.put('holiday/add', obj).then(response => response.data)
}
function deleteHoliday(id) {
  return $_app_server.delete("holiday/" + id + "/del")
}